import CategoryManage from '@/pages/categoryManage'
import ChannelClass from '@/pages/channelConfig/channelClass'
import ChannelLibrary from '@/pages/channelConfig/channelLibrary'
import LaunchPlatform from '@/pages/clueConfig/launchPlatform'
import CommodityArrive from '@/pages/commodityArrive'
import CommodityEdit from '@/pages/commodityEdit'
import CommodityManage from '@/pages/commodityManage'
import CompanyConfig from '@/pages/companyConfig'
import ContractTemplate from '@/pages/contractTemplate'
import AssignTasks from '@/pages/customerConfig/assignTasks'
import CustomerLabel from '@/pages/customerConfig/customerLabel'
import SalesBusiness from '@/pages/customerConfig/salesBusiness'
import DemoPage from '@/pages/demoPage'
import ClueAccountSet from '@/pages/getUsersConfig/clueAccountSet'
import MainPage from '@/pages/main'
import QuoteContract from '@/pages/quoteContract'
import SignTemplate from '@/pages/signTemplate'
import TemplateDetail from '@/pages/signTemplate/templateDetail'
import SellManage from '@/pages/sellManage'
import {BlackAndWhite} from '@/pages/baseProduct/blackandWhite'
import ExternalPerson from '@/pages/serviceConfig/externalPerson'
import ExternalPersonDetail from '@/pages/serviceConfig/externalPerson/detail' //工人管理
import InsuranceConfig from '@/pages/serviceConfig/insureManagement'
import FeeTemplateDetail from '@/pages/priceTagManage/templateDetail'

import MainRoute from '@/layouts/MainRoute.tsx'
import GeneralManage from '@/pages/baseProduct/generalManage'
import PackageTemplate from '@/pages/baseProduct/packageTemplate'
import AddOrEditPackageTemp from '@/pages/baseProduct/packageTemplate/addOrEdit'
import SetSpaceSpecs from '@/pages/baseProduct/packageTemplate/setSpaceSpecs'
import { ChildItemDetailTable } from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/step3/addOrEdit/childItemDetail'
import ParameterManage from '@/pages/baseProduct/parameterManage'
import PriceStrategy from '@/pages/baseProduct/priceStrategy'
import SubItemList from '@/pages/baseProduct/subItemManage'
import AddOrEditSubItem from '@/pages/baseProduct/subItemManage/addOrEdit'
import ChooseCategory from '@/pages/chooseCategory'
import ArticleManage from '@/pages/config/content/articleManage'
import ArticleEdit from '@/pages/config/content/edit'
import TagManage from '@/pages/config/content/tagManage'
import VideoManage from '@/pages/config/content/videoManage'
import VRManage from '@/pages/config/content/vrManage'
import EquityMember from '@/pages/config/member/equity'
import EquityTypeMember from '@/pages/config/member/equityType'
import EventMember from '@/pages/config/member/event'
import LevelMember from '@/pages/config/member/level'
import TaskMember from '@/pages/config/member/task'
import UserMember from '@/pages/config/member/user'
import ApplyChannelConfig from '@/pages/config/member/applyChannelConfig'//报名渠道配置
import UserMemberDetails from '@/pages/config/member/user/details'
import ActivityManage from '@/pages/crm/activityManage'
import AppCenter from '@/pages/homePage/appCenter'
import AppDetail from '@/pages/homePage/appCenter/detail'
import PersonalCenter from '@/pages/homePage/personalCenter'
import MessageChat from '@/pages/messageChat'
import DownloadsPage from '@/pages/page/downloads'
import PriceTagManage from '@/pages/priceTagManage'
import ProductClass from '@/pages/productClass'
import ProductManage from '@/pages/productManage'
import SPUManageTabList from '@/pages/productManage/tabList.tsx'
import ProductSteps from '@/pages/productManage/components/newProductSteps'
import SkuManage from '@/pages/productManage/components/skuListPage'
import CombinationManage from '@/pages/combinationManage';
import PublishManage from '@/pages/publishManage';
import ProjectManage from '@/pages/projectManage'
import CustomerConfig from '@/pages/serviceConfig/customerConfig'
import CustomerConfigDetail from '@/pages/serviceConfig/customerConfig/detail'
import NodeConfig from '@/pages/serviceConfig/nodeConfig'
import RetentionMoneyManagement from '@/pages/serviceConfig/retentionMoneyManagement'
import RetentionMoneyManagementAccountDetail from '@/pages/serviceConfig/retentionMoneyManagement/accountList/detail'
import WorkerManagement from '@/pages/serviceConfig/workerManagement'
import WorkerManagementDetail from '@/pages/serviceConfig/workerManagement/detail'
import Workshop from '@/pages/workshop'
import MainMenuRoute from './layouts/MainMenuRoute'

import BrandManage from '@/pages/brandManage'
import ImageProcess from '@/pages/imageProcess'
import BusinessConfiguration from '@/pages/businessConfiguration'
// 客户管理
import CallCenter from '@/pages/crm/callCenter'
import ClueList from '@/pages/crm/clueList'
import ClueImport from '@/pages/crm/clueList/clueImport'
import CustomerManageDetails from '@/pages/crm/customerManage/details'
import SellPlan from '@/pages/crm/sellPlan'
import SpecialConfigTable from '@/pages/priceTagManage/specialConfig'
import WorkerManagementAddOrEdit from './pages/serviceConfig/workerManagement/addOrEdit'
// 财务-收款服务
import PublicInformation from '@/pages/crm/publicInformation'
import PublicInfoDetail from '@/pages/crm/publicInformation/detail'
import PaymentService from '@/pages/paymentService'
import PaymentAllList from '@/pages/paymentService/paymentAllList'
import ReceivableAllList from '@/pages/paymentService/receivableAllList'
import RefundAllList from '@/pages/paymentService/refundAllList'
import AbnormalList from '@/pages/paymentService/abnormalList'
import ChangeRecord from '@/pages/paymentService/changeRecord'
import PaymentServiceDetails from '@/pages/paymentService/details'
import TransferInquiry from '@/pages/paymentService/transferList'
import LogManagement from '@/pages/paymentService/logManagement'
import CouponList from '@/pages/paymentService/couponList'
// 财务-配置
import BillPrintConfigManagement from '@/pages/fmsConfig/billPrintConfigManagement'
import CollectionCountDeployManagement from '@/pages/fmsConfig/collectionCountDeployManagement'
import CollectionVerification from '@/pages/fmsConfig/collectionVerification'
import EsignCopmpanyCfig from '@/pages/fmsConfig/esignCopmpanyCfig'
import FinancialAccountManagement from '@/pages/fmsConfig/financialAccountManagement'
import LendAgency from '@/pages/fmsConfig/lendAgency'
import WhiteListStrategy from '@/pages/fmsConfig/whiteListStrategy'
import ReceiptRulesManagement from '@/pages/fmsConfig/receiptRulesManagement'
import PlanDetails from '@/pages/fmsConfig/receiptRulesManagement/planDetails'
import ReceiveRefunds from '@/pages/fmsConfig/receiveRefunds'
import NicheList from '@/pages/nicheList'
import CategoryList from '@/pages/vip/categoryList'
import { MatterList } from '@/pages/vip/matterList'
import MatterDetail from '@/pages/vip/matterList/detail.tsx'
import { PendingList } from '@/pages/vip/pendingList'
import PendingDetail from '@/pages/vip/pendingList/detail.tsx'
import RepairList from '@/pages/vip/repairList'
// 产品内容配置
import ClosedManagement from '@/pages/customerConfig/closedManagement'
import StoreManagement from '@/pages/customerConfig/storeManagement'
import CustomerTabList from '@/pages/productContentConfig/customer'
import MeetReportEditor from '@/pages/productContentConfig/customer/editor'
import SpaceTypeManagement from '@/pages/productContentConfig/spaceTypeManagement'
import TalkOrderConfig from '@/pages/productContentConfig/talkOrderConfig'
import AdvertisingList from '@/pages/productContentConfig/talkOrderConfig/advertisingList'
import SecondConfig from '@/pages/productContentConfig/talkOrderConfig/secondConfig'
import SpaceVenueQRCodeList from '@/pages/productContentConfig/venueQRCode/space'

import { StandardTable } from '@/pages/baseProduct/components/standard/index'
import { DiscountFactor } from '@/pages/baseProduct/discountFactor'
import SpecialCodesManage from '@/pages/baseProduct/specialCodesManage'
import { SubItemDetail } from '@/pages/baseProduct/subItemManage/childItemDetail/index'
import UnitManage from '@/pages/baseProduct/unitManage'
import FlowChannelLog from '@/pages/channelConfig/channelLibrary/flowChannelLog'
import OrderService from '@/pages/orderService'
import CustomizedDrawings from '@/pages/orderService/details/customizedDrawings'
import DirectIndex from '@/pages/orderService/details/directIndex'
import DrawingManagement from '@/pages/orderService/details/drawingManagement'
import OrderDetails from '@/pages/orderService/details/index'
import QuoteSelection from '@/pages/orderService/quoteSelection'
import PoolingQuoteSelection from '@/pages/orderService/poolingQuoteSelection'
import SelectingMaterials from '@/pages/orderService/SelectingMaterials'
import ImportConfigList from '@/pages/priceTagManage/ImportConfig'
import LimitImportConfig from '@/pages/priceTagManage/LimitImportConfig'
import SalePlanTemplate from '@/pages/salePlanTemplate'
import FollowUpTask from './pages/customerConfig/followUpTask'
import ImageProcessList from '@/pages/imageProcess/imageProcessList'
import ImageProcessDetail from '@/pages/imageProcess/imageProcessDetail'

import EvalutionConfig from "@/pages/evaluateManage/evaluateConfig"
import EvaluateIndex from "@/pages/evaluateManage/evaluateIndex"
import EvaluateRecord from "@/pages/evaluateManage/evaluateRecord"
import EvaluateRecordEdit from './pages/evaluateManage/evaluateRecord/Edit'
import EvaluateRecordDetails from './pages/evaluateManage/evaluateRecord/Details'
import EvalutionQuestionClass from '@/pages/evaluateManage/evalutionQuestionClass'

import ChannelCallBack from '@/pages/callConfig/channelCallBack'
import Seating from '@/pages/callConfig/seating'
import ClueManage from '@/pages/clueManage'
import ClueDetail from '@/pages/clueManage/details'
import PreDispatchList from '@/pages/clueManage/preDispatchList'
import CallManage from '@/pages/crm/callCenter/callManage'
import SeatCommunicationCenter from '@/pages/crm/callCenter/seatCommunicationCenter'
import DesignPublicInfo from '@/pages/publicInfo/design'
import SalePublicInfo from '@/pages/publicInfo/sale'
import ShortageGoods from '@/pages/orderService/shortageGoods'
import KuklerAccount from "@/pages/crm/kuklerAccount";
import { KjlManager } from "@/pages/crm/kjlManager";
import { KjlManagerCopy } from "@/pages/crm/kjlManagerCopy";
import PublicTabList from "@/pages/crm/publicInformation/tabList.tsx";
import ClueAgent from "@/pages/clueConfig/clueAgent";
import ClueService from "@/pages/clueConfig/clueService";
import ClueBrand from "@/pages/clueConfig/clueBrand";
import AllList from "@/pages/clueManage/allList";
import CallConfiguration from "@/pages/callConfig";
import ChannelConfig from "@/pages/channelConfig";
import BuildingConfig from "@/pages/buildingConfig";
import TargetConfig from "@/pages/targetConfig";
import SalePlanTemp from "@/pages/salePlanTemplate/sale.tsx";
import BusinessPlanTemp from "@/pages/salePlanTemplate/business.tsx";
import ClueListNew from "@/pages/clueManage/clueList";
import ClueDetailNew from "@/pages/clueManage/clueList/detail.tsx";
import ClueListSale from "@/pages/clueManage/clueListSale";
import ClueDetailSale from "@/pages/clueManage/clueListSale/detail.tsx";
import SaleSeaDetail from "@/pages/publicInfo/sale/detail.tsx";
import ErrorList from "@/pages/clueManage/errorList";
import SalesDataPermission from "@/pages/salesDataPermission";
import StaffConfiguration from "@/pages/salesDataPermission/staffConfig";
import SalesWorkbenchList from '@/pages/salesWorkbench/workbenchList'
import DesignPublicDetailSale from "@/pages/publicInfo/design/detail.tsx";
import SalesWorkbenchDetail from '@/pages/salesWorkbench/workbenchList/components/clueList/detail'
import ChatAssignOperation from "@/pages/chatAssignOperation";
import MaterialDescription from "@/pages/baseProduct/materialDescription";
import CustomerDetail from '@/pages/saleOperations/saleWorkBench/customerDetail';

//业财组织转换引擎
import BillingSettingPage from '@/pages/fms/businessFinanceTransformEngine/billingSetting' //账套配置
import TransformLogPage from '@/pages/fms/businessFinanceTransformEngine/transformLog' //账套配置
import BusinessItemConfigPage from '@/pages/fms/businessFinanceTransformEngine/businessItemConfig' //账套配置
import ExpressionManagePage from '@/pages/fms/businessFinanceTransformEngine/expressionManage' //账套配置
import RulesConfigManagement from '@/pages/fms/businessFinanceTransformEngine/rulesConfigManagement'
// 呼叫工具
import {IntelligentOutboundCall} from "@/pages/callTool/intelligentOutboundCall";
import CallRecords from "@/pages/callTool/callRecords";
import OutboundCallAccess from "@/pages/callTool/outboundCallAccess"; //规则配置
// 智尺精灵
import RoomMeasurementManagePage from "@/pages/roomMeasurementTools/roomMeasurementManage";
import {AddOrEditRoomMeasureSteps} from "@/pages/roomMeasurementTools/roomMeasurementManage/modal/AddOrEditSteps"; //量房管理

// 客户管理
import CustomerProfile from './pages/customerProfile' // 客户档案
import CustomerProfileDetail from './pages/customerProfile/profileDetail'

// 方案产品
import SchemeProductList from '@/pages/baseProduct/schemeProductList'//方案产品-列表
import SchemeProductDetails from '@/pages/baseProduct/schemeProductList/schemeProductDetails'
import StandardConfigDetails from "@/pages/baseProduct/schemeProductList/standardConfigDetails";
import MaterialSelectionLibrary from '@/pages/MaterialSelectionLibrary'
import MaterialDetail from '@/pages/MaterialSelectionLibrary/MaterialDetail'

// 评价管理
import CitySatisfactionSurvey from "@/pages/evaluateManage/citySatisfactionSurvey";//满意度问卷-城市维度
import EmployeeSatisfactionSurvey from "@/pages/evaluateManage/employeeSatisfactionSurvey";//满意度问卷-员工维度
// 新版本选材
import QuoteSpaceSelection from '@/pages/orderServiceSpaceChoose/quoteSelection/index'
import PreviewList from './pages/orderServiceSpaceChoose/components/PreviewList'

import OutboundCallAnalysis from "@/pages/callTool/outboundCallAnalysis";
//方案产品-查看打包
const routes: any = [
  {
    path: '/main',
    element: <MainRoute />,
    children: [
      {
        path: 'home', // 个人工作台
        element: <MainPage />,
        // loader: teamLoader,
      },
      {
        path: 'chat', // 消息待办
        element: <MessageChat />,
        // loader: teamLoader,
      },
      // {
      //   快捷功能
      //   path: '/main/shortcutsList',
      //   element: <ShortcutsList/>,
      // },
      {
        path: 'personalCenter',
        element: <PersonalCenter />,
      },
      {
        path: 'appCenter',
        element: <AppCenter />,
      },
      {
        path: 'appCenter/:code',
        element: <AppDetail />,
      },
      // {
      //   管理员设置，暂不做
      //   path: '/main/adminConfig',
      //   element: <AdminConfig />,
      // },

      {
        path: 'download',
        element: <DownloadsPage />,
      },

      {
        path: 'demoPage/*', // 应用中心
        element: <DemoPage />,
        // loader: teamLoader,
      },
      {
        path: '', // 工作台
        element: <Workshop />,
        // loader: teamLoader,
      },
      {
        path: 'customerManage/assign', //消息跳转-分配设计师营销员操作
        element: <ChatAssignOperation />,
      },
    ],
  },
  {
    path: '/config',
    element: <MainMenuRoute />,
    children: [
      // {
      //   path: 'baseProduct',
      //   element: <BaseProduct />,
      // },
      {
        path: '/config/commodityManage',
        element: <CommodityManage />,
      },
      {
        path: '/config/commodityManage/commodityEdit/:id?',
        element: <CommodityEdit />,
      },
      {
        path: '/config/clueConfig/launchPlatform',
        element: <LaunchPlatform />,
      },
      {
        path: '/config/commodityManage/commodityArrive/:id',
        element: <CommodityArrive />,
        //   上下架
      },
      // 商品 - 品类管理
      {
        path: '/config/categoryManage',
        element: <CategoryManage />,
      },
      // 商品 - 销售类目管理
      {
        path: '/config/sellManage',
        element: <SellManage />,
      },
      {
        path: '/config/blackandwhite',
        element: <BlackAndWhite />,
      },
      // 打包模板
      {
        path: '/config/baseProduct/packageTemplate',
        element: <PackageTemplate />,
      },
      {
        path: '/config/baseProduct/packageTemplate/setSpaceSpecs/:id',
        element: <SetSpaceSpecs />,
      },
      {
        path: '/config/baseProduct/packageTemplate/addOrEdit/:id?',
        element: <AddOrEditPackageTemp />,
      },
      {
        path: '/config/baseProduct/packageTemplate/addOrEdit/childItemDetail/:id',
        element: <ChildItemDetailTable />,
      },
      // 子项管理
      {
        path: '/config/baseProduct/subItemList',
        element: <SubItemList />,
      },
      {
        path: '/config/baseProduct/subItemList/detailList/:id',
        element: <SubItemDetail />,
      },
      {
        path: '/config/baseProduct/subItemList/addOrEdit/:id?',
        element: <AddOrEditSubItem />,
      },
      // 价格策略
      {
        path: '/config/baseProduct/priceStrategy',
        element: <PriceStrategy />,
      },
      // 通项管理
      {
        path: '/config/baseProduct/generalManage',
        element: <GeneralManage />,
      },
      // 标配管理
      {
        path: '/config/baseProduct/generalManage/standard-feature/:genItemId?',
        element: <StandardTable />,
      },
      {
        path: '/config/baseProduct/discountFactor', // 优惠系数
        element: <DiscountFactor />,
      },
      // 参数管理
      {
        path: '/config/baseProduct/parameterManage',
        element: <ParameterManage />,
      },
      // 产品管理
      {
        path: '/config/productManage',
        element: <SPUManageTabList />,
      },
      // 组合打包
      {
        path: '/config/combinationManage',
        element: <CombinationManage />,
      },
      // 发包配置
      {
        path: '/config/publishManage',
        element: <PublishManage />,
      },
      {
        path: '/config/skuManage',
        element: <SkuManage />,
      },
      // 选品
      {
        path: '/config/chooseCategory',
        element: <ChooseCategory />,
      },
      // 产品分类
      {
        path: '/config/productClass',
        element: <ProductClass />,
      },
      // 活动管理
      {
        path: '/config/activityManage',
        element: <ActivityManage />,
      },
      // 项目管理
      {
        path: '/config/projectManage',
        element: <ProjectManage />,
      },
      // 品牌管理
      {
        path: '/config/brandManage',
        element: <BrandManage />,
      },
      // 订单配置
      {
        path: '/config/imageProcess',
        element: <ImageProcess />,
      },
      // 业务字典
      {
        path: '/config/businessConfiguration',
        element: <BusinessConfiguration />,
      },
      // 费用项
      {
        path: '/config/priceTagManage',
        element: <PriceTagManage />,
      },
      // 费用模版-模版配置
      {
        path: '/config/priceTagManage/templateDetail/:id/:name',
        element: <FeeTemplateDetail />,
      },
      // 费用项-特殊配置
      {
        path: '/config/priceTagManage/specialConfig/:id',
        element: <SpecialConfigTable />,
      },
      // 费用项-导入费用
      {
        path: '/config/priceTagManage/importConfig/:id',
        element: <ImportConfigList />,
      },
      // 费用项-限购 导入费用
      {
        path: '/config/priceTagManage/limitImportConfig/:id',
        element: <LimitImportConfig />,
      },
      // 特项代码
      {
        path: '/config/specialCodesManage',
        element: <SpecialCodesManage />,
      },
      // {
      //   path: '/config/specialCodesManageAddOrEdit',
      //   element: <PriceTagManage />,
      // },
      // 产品管理新增
      {
        path: '/config/productManage/productSteps/:id?',
        element: <ProductSteps />,
      },
      // 报价合同
      {
        path: '/config/quoteContract',
        element: <QuoteContract />,
      },
      // 签约模版
      {
        path: '/config/signTemplate',
        element: <SignTemplate />,
      },
      // 签约模版详情
      {
        path: '/config/signTemplate/templateDetail/:id/:name',
        element: <TemplateDetail />,
      },
      // 合同模板
      {
        path: '/config/contractTemplate',
        element: <ContractTemplate />,
      },
      // 分公司打印变量配置
      {
        path: '/config/companyConfig',
        element: <CompanyConfig />,
      },
      {
        path: '/config/evaluateConfig',
        element: <CompanyConfig />,
      },
      {
        path: '/config/article-manage',
        element: <ArticleManage />,
      },
      {
        path: '/config/vr-manage',
        element: <VRManage />,
      },
      {
        path: '/config/video-manage',
        element: <VideoManage />,
      },
      {
        path: '/config/tag-manage',
        element: <TagManage />,
      },
      {
        path: '/config/edit',
        element: <ArticleEdit />,
      },
      {
        path: '/config/member/level',
        element: <LevelMember />,
      },
      {
        path: '/config/member/equity',
        element: <EquityMember />,
      },
      {
        path: '/config/member/equity-type',
        element: <EquityTypeMember />,
      },
      {
        path: '/config/member/task',
        element: <TaskMember />,
      },
      {
        path: '/config/member/event',
        element: <EventMember />,
      },
      {
        path: '/config/member/user',
        element: <UserMember />,
      },
      {
        path: '/config/member/user/details',
        element: <UserMemberDetails />,
      },
      {
        path: '/config/member/applyChannelConfig', //报名渠道配置
        element: <ApplyChannelConfig />,
      },
      {
        path: '/config/customerConfig/customerLabel',
        element: <CustomerLabel />,
      },
      // 分配人管理
      {
        path: '/config/dispatchManagement/assignTasks',
        element: <AssignTasks />,
      },
      {
        path: '/config/customerConfig/salesBusiness',
        element: <SalesBusiness />,
      },
      {
        path: '/config/serviceConfig/insuranceConfig',
        element: <InsuranceConfig />,
      },
      {
        path: '/config/serviceConfig/externalPerson',
        element: <ExternalPerson />,
      },
      {
        path: '/config/serviceConfig/externalPerson/detail/:id',
        element: <ExternalPersonDetail />,
      },
      {
        path: '/config/serviceConfig/retentionMoneyManagement/accountDetail/:id',
        element: <RetentionMoneyManagementAccountDetail />,
      },
      {
        path: '/config/serviceConfig/nodeConfig',
        element: <NodeConfig />,
      },
      {
        path: '/config/serviceConfig/serviceManage',
        element: <CustomerConfig />,
      },
      {
        path: '/config/serviceConfig/serviceManage/detail/:id',
        element: <CustomerConfigDetail />,
      },
      {
        path: '/config/serviceConfig/workerManagement',
        element: <WorkerManagement />,
      },
      {
        path: '/config/serviceConfig/workerManagement',
        element: <WorkerManagement />,
      },
      {
        path: '/config/serviceConfig/workerManagement/add',
        element: <WorkerManagementAddOrEdit />,
      },
      {
        path: '/config/serviceConfig/workerManagement/edit/:id',
        element: <WorkerManagementAddOrEdit />,
      },
      {
        path: '/config/serviceConfig/workerManagement/detail/:id',
        element: <WorkerManagementDetail />,
      },
      {
        path: '/config/serviceConfig/retentionMoney',
        element: <RetentionMoneyManagement />,
      },
      // {
      //   path: '/config/buildingConfig/buildingList',
      //   element: <BuildingList />,
      // },
      // {
      //   path: '/config/buildingConfig/buildingArea',
      //   element: <BuildingArea />,
      // },
      // {
      //   path: '/config/buildingConfig/developerlist',
      //   element: <Developerlist />,
      // },
      // {
      //   path: '/config/targetConfig/achievementDate', // 业绩期管理
      //   element: <AchievementDate />,
      // },
      // {
      //   path: '/config/targetConfig/objectiveManage', // 目标管理
      //   element: <ObjectiveManage />,
      // },
      {
        path: '/config/channelConfig/channelClass',
        element: <ChannelClass />,
      },
      {
        path: '/config/channelConfig/channelLibrary',
        element: <ChannelLibrary />,
      },
      {
        path: '/config/channelConfig/channelLibrary/logs/:id',
        element: <FlowChannelLog />,
      },
      //财务-配置
      {
        path: '/config/esignCopmpanyCfig',
        element: <EsignCopmpanyCfig />,
      },
      {
        path: '/config/financialAccountManagement',
        element: <FinancialAccountManagement />,
      },
      {
        path: '/config/receiptRulesManagement',
        element: <ReceiptRulesManagement />,
      },
      {
        path: '/config/receiptRulesManagement/:id',
        element: <PlanDetails />,
      },
      {
        path: '/config/collectionCountDeployManagement',
        element: <CollectionCountDeployManagement />,
      },
      {
        path: '/config/billPrintConfigManagement',
        element: <BillPrintConfigManagement />,
      },
      {
        path: '/config/receiveRefunds',
        element: <ReceiveRefunds />,
      },
      {
        path: '/config/collectionVerification',
        element: <CollectionVerification />,
      },
      {
        path: '/config/lendAgency',
        element: <LendAgency />,
      },
      {
        path: '/config/whiteListStrategy',
        element: <WhiteListStrategy />,
      },

      // 产品内容配置：
      // 场馆二维码
      {
        path: '/config/venueQRCodeList',
        element: <SpaceVenueQRCodeList />,
      },
      // 谈单管理
      {
        path: '/config/customerTalkOrder',
        element: <CustomerTabList />,
      },
      // 内容管理
      {
        path: '/config/talkOrderConfig',
        element: <TalkOrderConfig />,
      },
      {
        path: '/config/talkOrderConfig/advertisingList/:id/:name',
        element: <AdvertisingList />,
      },
      {
        path: '/config/talkOrderConfig/secondConfig/:id',
        element: <SecondConfig />,
      },
      // {
      //   path: '/config/talkOrderConfig/advertBuildingList',
      //   element: <AdvertBuildingList />,
      // },//楼盘方案
      // {
      //   path: '/config/talkOrderConfig/advertBuildingList/secondConfig/:buildPlanId',
      //   element: <AdvertBuildingConfigList />,
      // },//楼盘方案配置

      // 空间管理
      {
        path: '/config/spaceTypeManagement',
        element: <SpaceTypeManagement />,
      },
      {
        path: '/config/meetReportEditor',
        element: <MeetReportEditor />,
      },
      // {
      //   path: '/config/customerConfig/closed-management', // 关闭管理
      //   element: <ClosedManagement />,
      // },
      // {
      //   path: '/config/customerConfig/follow-up-uask-management', // 跟进任务管理
      //   element: <FollowUpTask />,
      // },
      // // 线索账号配置
      // {
      //   path: '/config/getUsersConfig/clueAccountSet',
      //   element: <ClueAccountSet />,
      // },
      //
      // // 线索代理商
      // {
      //   path: '/config/getUsersConfig/clueAgent',
      //   element: <ClueAgent />,
      // },
      // // 线索军种
      // {
      //   path: '/config/getUsersConfig/clueService',
      //   element: <ClueService />,
      // },
      // // 线索品牌
      // {
      //   path: '/config/getUsersConfig/clueBrand',
      //   element: <ClueBrand />,
      // },

      // {
      //   path: '/config/getUsersConfig/clueAccountSet/clueAccountSetChangeLog/:id',
      //   element: <ClueAccountSetChangeLog />,
      // },
      // {
      //   path: '/config/getUsersConfig/clueAccountSet/clueAccountCashAllocationConfig/:id',
      //   element: <ClueAccountCashAllocationConfigPage />,
      // },
      {
        path: '/config/customerConfig/salePlanTemplate', // 销售计划模板
        element: <SalePlanTemplate />,
      },
      {
        path: '/config/unitManage', // 单位管理
        element: <UnitManage />,
      },

      // {
      //   path: '/config/customerConfig/salePlanTemplate',// 销售计划模板
      //   element: <SalePlanTemplate />,
      // },
      //   线索配置
      {
        path: '/config/clueConfig/clueAccountSet', // 线索账号
        element: <ClueAccountSet />,
      },
      {
        path: '/config/clueConfig/clueAgent', //线索代理商
        element: <ClueAgent />,
      },
      {
        path: '/config/clueConfig/clueService', //线索军种
        element: <ClueService />,
      },
      {
        path: '/config/clueConfig/clueBrand', //线索品牌
        element: <ClueBrand />,
      },
      {
        path: '/config/evalutionConfig', //评价配置
        element: <EvalutionConfig />,
      },
      {
        path: '/config/evalutionIndex', //评价指标
        element: <EvaluateIndex />,
      },
      {
        path: '/config/evalutionRecord', //分发记录
        element: <EvaluateRecord />,
      },
      {
        path: '/config/evalutionRecord/edit/:id?', //分发记录编辑
        element: <EvaluateRecordEdit />,
      },
      {
        path: '/config/evalutionRecord/detail/:id', //分发记录详情
        element: <EvaluateRecordDetails />,
      },
      {
        path: '/config/evalutionQuestionClass',//问题分类
        element: <EvalutionQuestionClass />,
      },
      {
        path: '/config/citySatisfactionSurvey', //满意度问卷-城市维度2
        element: <CitySatisfactionSurvey />,
      },
      {
        path: '/config/employeeSatisfactionSurvey', //满意度问卷-员工维度2
        element: <EmployeeSatisfactionSurvey />,
      },

      //业财组织转换引擎
      {
        path: '/config/billingSetting',
        element: <BillingSettingPage />,
      },
      {
        path: '/config/transformLog',
        element: <TransformLogPage />,
      },
      {
        path: '/config/businessItemConfig',
        element: <BusinessItemConfigPage />,
      },
      {
        path: '/config/expressionManage',
        element: <ExpressionManagePage />,
      },
      {
        path: '/config/rulesConfig',
        element: <RulesConfigManagement />,
      },
      // 工艺及物料说明
      {
        path: '/config/baseProduct/materialDescription',
        element: <MaterialDescription />,
      },
      // 方案产品
      {
        path: '/config/schemeProductList',
        element: <SchemeProductList />,
      },
      {
        path: '/config/schemeProductDetails/:id?',//产品详情
        element: <SchemeProductDetails />,
      },
      {
        path: '/config/standardConfigDetails/:id?',//标配情况
        element: <StandardConfigDetails />,
      },
    ],
  },
  {
    path: '/customerManage',
    element: <MainMenuRoute />,
    children: [
      {
        path: '/customerManage/clueList', // 线索列表
        element: <ClueList />,
      },
      {
        path: '/customerManage/clueManage/clueAccountSet', // 线索配置 - 线索账号
        element: <ClueAccountSet />,
      },
      {
        path: '/customerManage/salePlanTemplate', // 销售计划模板
        element: <SalePlanTemplate />,
      },
      {
        path: '/customerManage/publicInformation',
        element: <PublicInformation />,
      },
      {
        path: '/customerManage/publicInformation/details/:id/:customerId',
        element: <PublicInfoDetail />,
      },
      {
        path: '/customerManage/nicheList', // 商机列表
        element: <NicheList />,
      },
      {
        path: '/customerManage/nicheList/detail/:id/:customerId', // 商机列表-详情
        element: <CustomerManageDetails />,
      },
      {
        path: '/customerManage/sellPlan', // 销售计划
        element: <SellPlan />,
      },
      // {
      //   path: '/customerManage/kuklerAccount', // 销售计划 - 去设计大师 - 账号管理
      //   element: <KuklerAccount />,
      // },
      {
        path: '/customerManage/kjlManager/:id?', // 销售计划 - 去设计大师 - 绑定酷家乐方案
        element: <KjlManager />,
      },
      {
        path: '/customerManage/kjlManagerCopy/:id?', // 销售计划 - 去设计大师 - 复制已有方案绑定
        element: <KjlManagerCopy />,
      },
      {
        path: '/customerManage/callCenter', // 智能外呼
        element: <CallCenter />,
      },
    ],
  },
  {
    path: '/issues',
    element: <MainMenuRoute />,
    children: [
      {
        path: '/issues/matterList', //问题列表
        element: <MatterList />,
      },
      {
        path: '/issues/matterList/detail/:id', //问题列表 -详情
        element: <MatterDetail />,
      },
      {
        path: '/issues/pendingList', //工单列表
        element: <PendingList />,
      },
      {
        path: '/issues/pendingList/detail/:id?/:issueId?/:companyCode?', //工单列表
        element: <PendingDetail />,
      },
      {
        path: '/issues/repairList', //报修列表
        element: <RepairList />,
      },
      {
        path: '/issues/categoryList', //报事报修分类
        element: <CategoryList />,
      },
    ],
  },
  {
    path: '/saleOp',
    element: <MainMenuRoute />,
    children: [
      //   智能外呼
      // {
      //   path: '/saleOp/callCenter/callManage', //呼叫管理
      //   element: <CallManage />
      // },
      // {
      //   path: '/saleOp/callCenter/callRecords', //通话记录
      //   element: <SeatCommunicationCenter />
      // },
      //销售工作台
      {
        path: '/saleOp/salesWorkbench/list', //销售工作台
        element: <SalesWorkbenchList />,
      },
      //销售工作台
      {
        path: '/saleOp/salesWorkBench/salesWorkBenchDetail/:id', //销售工作台
        element: <CustomerDetail />,
      },
      //销售工作台-设计无效tab详情
      {
        path: '/saleOp/salesWorkBench/salesWorkBenchDetail/design/:id',
        element: <DesignPublicDetailSale />,
      },
      //   商机运营
      {
        path: '/saleOp/businessManage/clueImport', //线索导入
        element: <ClueImport />,
      },
      {
        path: '/saleOp/businessManage/cluePreDispatch', //入库前线索
        element: <PreDispatchList />,
      },
      {
        path: '/saleOp/businessManage/callManage', //智能外呼
        element: <CallCenter />,
      },
      {
        path: '/saleOp/businessManage/clueDispatch', //已入库线索
        element: <AllList />,
      },
      {
        path: '/saleOp/businessManage/clueDispatch/clueDetail/:id', //已入库线索
        element: <CustomerDetail />,
      },
      {
        path: '/saleOp/businessManage/clueList', //商机运营(商机列表)
        element: <ClueListNew />,
      },
      {
        path: '/saleOp/businessManage/clueDetail/:id',
        element: <ClueDetailNew />,
      },
      {
        path: '/saleOp/businessManage/salePublicInfo', //营销公海{无效列表}
        element: <SalePublicInfo />,
      },
      {
        path: '/saleOp/businessManage/salePublicInfo/detail/:id', //营销公海{无效列表}
        element: <SaleSeaDetail />,
      },
      {
        path: '/saleOp/businessManage/errorList', //异常列表
        element: <ErrorList />,
      },
      //     销售计划
      {
        path: '/saleOp/sellPlan/clueListSale', //销售计划(需求列表)
        element: <ClueListSale />,
      },

      {
        path: '/saleOp/sellPlan/clueDetailSale/:id',
        element: <ClueDetailSale />,
      },
      {
        path: '/saleOp/sellPlan/designPublicInfo', //设计公海{飞单列表}
        element: <DesignPublicInfo />,
      },
      {
        path: '/saleOp/sellPlan/designPublicInfo/:id', //设计公海{飞单列表}
        element: <DesignPublicDetailSale />,
      },
      //     智能派单-子应用PC-CRM
      {
        path: '/saleOp/intelligentDispatch/store', // 派门店
        element: <StoreManagement />,
      },
      //     销售配置
      {
        path: '/saleOp/saleConfig/targetConfig', //目标配置
        element: <TargetConfig />,
      },
      {
        path: '/saleOp/saleConfig/planTemplate', //销售计划模板
        element: <SalePlanTemp />,
      },
      {
        path: '/saleOp/saleConfig/cluePlanTemplate', //商机计划模板
        element: <BusinessPlanTemp />,
      },
      {
        path: '/saleOp/saleConfig/saleTool', //销售工具
        element: <FollowUpTask />,
      },
      {
        path: '/saleOp/saleConfig/closeConfig', //关闭配置
        element: <ClosedManagement />,
      },
      {
        path: '/saleOp/saleConfig/salesDataPermission', //销运数据权限
        element: <SalesDataPermission />,
      },
      {
        path: '/saleOp/saleConfig/salesDataPermission/:id', //销运数据权限-人员配置
        element: <StaffConfiguration />,
      },
      //     基础配置
      {
        path: '/saleOp/basicConfig/tagConfig', // 标签配置
        element: <CustomerLabel />,
      },
      {
        path: '/saleOp/basicConfig/kuklerAccount', // 酷家乐账号
        element: <KuklerAccount />,
      },

      {
        path: '/saleOp/basicConfig/kjlManager/:id?', // 销售计划 - 去设计大师 - 绑定酷家乐方案
        element: <KjlManager />,
      },
      {
        path: '/saleOp/basicConfig/kjlManagerCopy/:id?', // 销售计划 - 去设计大师 - 复制已有方案绑定
        element: <KjlManagerCopy />,
      },
      {
        path: '/saleOp/basicConfig/channelConfig', // 渠道配置
        element: <ChannelConfig />,
      },
      {
        path: '/saleOp/basicConfig/buildingConfig', // 楼盘配置
        element: <BuildingConfig />,
      },
      {
        path: '/saleOp/basicConfig/callConfig', // 呼叫配置
        element: <CallConfiguration />,
      },
      //  速联热线 (呼叫工具)
      {
        path: '/saleOp/callTool/intelligentOutboundCall', // 智能外呼
        element: <IntelligentOutboundCall />,
      },
      {
        path: '/saleOp/callTool/callRecords', // 呼叫记录
        element: <CallRecords />,
      },
      {
        path: '/saleOp/callTool/outboundCallAnalysis', // 外呼分析
        element: <OutboundCallAnalysis />,
      },
      {
        path: '/saleOp/callTool/outboundCallAccess', // 外呼接入
        element: <OutboundCallAccess />,
      },
      // 智尺精灵(量房工具)
      {
        path: '/saleOp/roomMeasurementTools/management', // 量房管理
        element: <RoomMeasurementManagePage />,
      },
      {
        path: '/saleOp/roomMeasurementTools/management/addOrEdit/:id?', // 量房管理
        element: <AddOrEditRoomMeasureSteps />,
      },
    ],
  },
  // 收款服务
  {
    path: '/fms',
    element: <MainMenuRoute />,
    children: [
      {
        path: '/fms/paymentService',
        element: <PaymentService />,
      },
      //新增退款、应收、收款
      {
        path: '/fms/paymentService/paymentAllList',
        element: <PaymentAllList />,
      },
      {
        path: '/fms/paymentService/receivableAllList',
        element: <ReceivableAllList />,
      },
      {
        path: '/fms/paymentService/refundAllList',
        element: <RefundAllList />,
      },
      {
        path: '/fms/paymentService/:id/:orderId/:dealMode',
        element: <PaymentServiceDetails />,
      },
      {
        path: '/fms/paymentService/abnormalList',
        element: <AbnormalList />,
      },
      {
        path: '/fms/paymentService/changeRecord/:id',
        element: <ChangeRecord />,
      },
      {
        path: '/fms/paymentService/transferInquiry/:id',
        element: <TransferInquiry />,
      },
      {
        path: '/fms/paymentService/kdLog',
        element: <LogManagement />,
      },
      {
        path: '/fms/paymentService/couponList',
        element: <CouponList />,
      },
    ],
  },
  {
    path: '/order',
    element: <MainMenuRoute />,
    children: [
      {
        path: '/order/list',
        element: <OrderService />,
      },
      {
        path: '/order/list/details/:id?',
        element: <OrderDetails />,
      },
      {
        path: '/order/list/details/drawing-management/:id?/:orderId?',
        element: <DrawingManagement />,
      },
      {
        path: '/order/list/details/customized-drawings/:id?/:orderId?',
        element: <CustomizedDrawings />,
      },
      {
        path: '/order/list/details/direct-index/:id?',
        element: <DirectIndex />,
      },
      {
        path: '/order/list/details/quote-selection/:budgetId?',
        element: <QuoteSelection />,
      },
      {
        path: '/order/list/details/quote-selection/selecting-materials/:budgetId?/:refItemId?/:type?',
        element: <SelectingMaterials />,
      },
      {
        path: '/order/list/details/shortageGoods/:budgetId?',
        element: <ShortageGoods />,
      },
      // 资金池选材 软装
      {
        path: '/order/list/details/pooling-quote-selection/:budgetId?',
        element: <PoolingQuoteSelection />,
      },
      {
        path: '/order/materialSelectionLibrary',
        element: <MaterialSelectionLibrary />,
      },
      {
        path: '/order/materialSelectionLibrary/materialDetail/:id?/:filterOrgId?/:filterGoodsId?',
        element: <MaterialDetail />,
      },
      {
        path: '/order/processList',
        element: <ImageProcessList />,
      },
      {
        path: '/order/processDetail/:id?',
        element: <ImageProcessDetail />
      },
      // 新版本-以空间为单位选材
      {
        path: '/order/list/details/quote-space-selection/:budgetId?',
        element: <QuoteSpaceSelection />,
      },
      {
        path: '/order/list/details/quote-space-selection/preview-list/:budgetId?',
        element: <PreviewList />,
      },
    ],
  },
  // 客户管理
  {
    path: '/CrmPlus',
    element: <MainMenuRoute />,
    children: [
      // 客户档案
      {
        path: '/CrmPlus/customerProfile',
        element: <CustomerProfile />,
      },
      // 客户档案详情
      {
        path: '/CrmPlus/customerProfileDetail/:id',
        element: <CustomerProfileDetail />,
      },
    ],
  },
]

export default routes
